module.exports = __webpack_public_path__ + "static/finding-my-leadership-voice-image-1-533x800-32045373362e0835ec4b190a6db38007.jpg";